export function formatAddress(point) {
  let address = "";

  if (point.address) {
    if (point.address) address += point.address;
    if (point.address_number) address += `, ${point.address_number}`;
    if (point.address_district) address += ` - ${point.address_district}`;
    if (point.address_city) address += ` - ${point.address_city}`;
    if (point.address_state) address += ` - ${point.address_state}`;
  } else {
    if (point.address_fallback) address += point.address_fallback;
    if (point.address_number_fallback)
      address += `, ${point.address_number_fallback}`;
    if (point.address_district_fallback)
      address += ` - ${point.address_district_fallback}`;
    if (point.address_city_fallback)
      address += ` - ${point.address_city_fallback}`;
    if (point.address_state_fallback)
      address += ` - ${point.address_state_fallback}`;
  }
  return address;
}

export function formatAddressShort(point) {
  let address = "";

  if (point.address) {
    if (point.address) address += point.address;
    if (point.address_number) address += `, ${point.address_number}`;
  } else {
    if (point.address_fallback) address += point.address_fallback;
    if (point.address_number_fallback)
      address += `, ${point.address_number_fallback}`;
  }
  return address;
}
